module.exports = __webpack_public_path__ + "img/tab_analytics.85f85805.svg";